import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isDisabled: boolean
}

export const HeaderRow = styled(ButtonPlain)<Props>`
	align-items: center;
	display: flex;
	overflow-wrap: break-word;
	font: ${helpers.fonts.body.medium};
	color: ${helpers.color.text};
	padding: ${helpers.spacing.medium} ${helpers.spacing.large};
	gap: ${helpers.spacing.medium};

	transition: background-color 150ms ${helpers.animation.default};
	cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};

	&:hover:not(:disabled) {
		background-color: ${({ isDisabled, theme }) => !isDisabled && transparentize(0.85, theme.color.actionHover)};
	}
`
